import { Component } from '@angular/core';
import { DialogBase, DialogOptions } from '@context/frontend/common';
import { DetailMenuItem } from '@context/shared/types/common';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiButton } from '@taiga-ui/core';

@Component({
	imports: [TranslocoModule, TuiButton],
	selector: 'ctx-detail-menu-dialog',
	templateUrl: 'detail-menu-dialog.component.html',
})
export class DetailMenuDialogComponent extends DialogBase<
	DetailMenuItem,
	{ menuItems: DetailMenuItem[] }
> {
	static override readonly DialogOptions = { size: 's' } as DialogOptions;

	onClick(item: DetailMenuItem) {
		item.handler();
		this.context.completeWith(item);
	}
}
